import { AccessRelationship } from "@istari/istari-client";

import { useGetSystemAccessById } from "~/api/useSystems";
import { userGrantTypeFromAccessRelation } from "~/enums/UserGrantType";
import { getCanUserEdit } from "~/permissions";
import { useCurrentUser } from "~/user/feature/use-current-user";

export interface CanEditSystem {
  canEdit: boolean;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useCanEditSystem(systemId: string | undefined): CanEditSystem {
  const accessQuery = useGetSystemAccessById(systemId, true);
  const currentUser = useCurrentUser();

  const currentUserId = currentUser.status === "ready" ? currentUser.userId : undefined;
  const relation = accessQuery.data?.find((grant: AccessRelationship) => grant.subjectId === currentUserId)?.relation;
  const permission = relation ? userGrantTypeFromAccessRelation(relation) : undefined;

  const isLoading = accessQuery.isLoading || currentUser.status === "loading";
  const isError = accessQuery.isError || currentUser.status === "error";

  return {
    canEdit: !isLoading && !isError && getCanUserEdit(permission),
    isLoading,
    isError,
    refetch: () => void accessQuery.refetch(),
  };
}
